module.exports = __webpack_public_path__ + "img/contact12.15bb019b.png";